
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'supplieruploadIndex',
		props: {
			currentRow: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				moduleName: 'supplierupload',
				windowName: '同步万里牛',
				windowType: 'modal',
			}
		},
		watch: {
			currentRow(e){
				this.foreingKey.supplierid = e.id
				this.customreload()
			}
		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			alterInitList(){
				//this.operateButtonConfig = []
			},
			beforeCreateGrid(formConfig, columns, gridOptions){
				formConfig.enabled = false
				gridOptions.toolbarConfig.enabled = false
				gridOptions.pagerConfig.enabled = false
			},
			list(page,updateForm,other) {
				return new Promise((resolve,reject) => {
					this.$api[this.moduleName].list({
						...page,
						...updateForm,
						...other,
						...this.foreingKey
					}).then((res) => {
						if (this.afterGet) {
							this.afterGet(res,updateForm)
						}
						this.sourcedata = res
						resolve(res)
					}, () => {
						reject()
					})
				})
			},
		},
		components: {
			
		}
	}
</script>